import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  FacebookAuthProvider,
  TwitterAuthProvider 
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBAvfCxvZBy9RuRXtwg7lvqeoY-xQtdLOc",
  authDomain: "alhajiinusahfoundation.firebaseapp.com",
  projectId: "alhajiinusahfoundation",
  storageBucket: "alhajiinusahfoundation.firebasestorage.app",
  messagingSenderId: "477200515072",
  appId: "1:477200515072:web:fa2659ee396e2d5e8d58e5",
  measurementId: "G-HXHMT9X4LK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Social providers
export const googleProvider = new GoogleAuthProvider();
export const facebookProvider = new FacebookAuthProvider();
export const twitterProvider = new TwitterAuthProvider();

// Configure providers
googleProvider.setCustomParameters({
  prompt: 'select_account'
});
googleProvider.addScope('email');
googleProvider.addScope('profile');

facebookProvider.addScope('email');
facebookProvider.addScope('public_profile');

export default app;